module.exports = __webpack_public_path__ + "static/media/ahorro-seguro.f60cb922.png";